<template>
  <Modal :id="'cmp-accounting-costs-add_costs'" @cancelled="onCancel">
    <template slot="header"> {{$t('new_costs')}} </template>
    <template slot="body">
      <SearchList
        :id="'contacts'"
        :items="items"
        :keyProperty="'contact_id'"
        :label="'fullname'"
        :placeholder="'Search'"
        :selectionNumber="'radio'"
        @selected="onContactItemClick"
         @searched="onContactSearched"
      />
      <div class="form-group">
          <TextField
            class="m1" 
            :type="'date'"
            :id="'invoice_date'"
            v-bind="textFieldConfig"
            :placeholder="$t('invoice_date')"
            required
            :showValidationIcons="true"
            :immediateValidation="true"
            :value="newData.invoice_date"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
        />
        <Dropdown
          :id="'cost_group_id'"
          class="m2"
          :options="costGroupTV"
          :selected="costGroupTV.find((b) => b.value == newData.cost_group_id)"
          :placeholder="$t('select_cost_group')"
          deselect
          box
           required
          :showValidationIcons="true"
          :immediateValidation="true"
          v-on:selectedChange="(e) => onDropdownChange('cost_group_id', e)"
          @validated="e => onValidation('cost_group_id', e)"
        ></Dropdown>

        <Dropdown
          :id="'invoice_project_id'"
          class="m2"
          :options="invoice_projectsTV"
          :selected="
            invoice_projectsTV.find(
              (b) => b.value == newData.invoice_project_id
            )
          "
          :placeholder="$t('select_invoice_project')"
          deselect
          box
           required
          :showValidationIcons="true"
          :immediateValidation="true"
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
          @validated="e => onValidation('invoice_project_id', e)"
        ></Dropdown>

        <Dropdown
          :id="'currency_id'"
          class="m2"
          :options="currencyTV"
          :selected="currencyTV.find((b) => b.value == newData.currency_id)"
          :placeholder="$t('select_currency')"
          deselect
          box
           required
          :showValidationIcons="true"
          :immediateValidation="true"
          v-on:selectedChange="(e) => onDropdownChange('currency_id', e)"
          @validated="e => onValidation('currency_id', e)"
        ></Dropdown>

        <TextField
          class="m1" 
          :id="'external_ref'"
           v-bind="textFieldConfig"
           :placeholder="$t('external_no')"
           required
          :showValidationIcons="true"
          :immediateValidation="true"
          :value="newData.external_ref"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>

        <TextField
          class="m1" 
          :id="'subject'"
          v-bind="textFieldConfig"
          :placeholder="$t('subject')"
          required
           :showValidationIcons="true"
          :immediateValidation="true"
          :value="newData.subject"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
         :disabled="!isFormValid "
        class="dt-button v1 with-ico s6"
        @click.stop="onClickOK"
      >
        <div class="button-text">
          {{ $t("ok") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapKeyToAction } from "../../../../store/global";
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import SearchList from "@dtplugins/search-list/search-list";
import InputField from "@plugins/text-field/input-field";
import TextField from "@plugins/text-field/text-field";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet } from "../../../../utility";
import { CostsService } from "../../services/costs.service";
import { createTV, tv } from "../../../../models/text-value.model";
import { format } from "date-fns";
import Modal from "@dtplugins/modal/modal";
export default {
  components: {
    InputField,
    TextField,
    Modal,
    SearchList,
  },
  props: {
    // costData: {
    //   type: Object,
    // },
    calendarDate: {
      type: String,
      default: format(new Date(), "YYYY-MM-DD"),
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: false,
      },
      validationResult: {},
      costData:{},
      newData: {
        contact_id: "",
        invoice_date: '',
        cost_group_id: "",
        invoice_project_id: "",
        currency_id: "",
        external_ref: "",
        subject: "",
      },
      contacts: [],
      invoiceDateMenu: null,
      selectedContacts: new Set(),
    };
  },
  mounted:async function () {
    const resData = await CostsService.findCostAddData();
    this.costData = resData.data;
    console.log("::::::::::::::",resData)
  },
  watch: {},
  computed: {
    items: function () {
      return this.costData?.contacts || [];
    },
    costGroupTV: function () {
      return createTV(
        this.costData?.cost_groups,
        "cost_group_name",
        "cost_group_id"
      );
    },
    invoice_projectsTV: function () {
      return createTV(
        this.costData?.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    currencyTV: function () {
      return createTV(this.costData?.currencies, "currency_iso", "currency_id");
    },
    isFormValid: function () {
       return Object.values(this.validationResult).every(e => e.valid);
    },
  },
  methods: {
    onCancel() {
      this.$emit("cancelled");
    },

    async onClickOK() {

      console.log("NEW DATA",this.newData);
      const invoice = await CostsService.addNewCost(this.newData) 
      console.log("INVOICE:::::::",invoice)
      if(this.newData.contact_id!=0){
        const { invoice_id } = invoice.data.invoice
        await CostsService.updateCostContact(invoice_id,this.newData.contact_id);
      }
      this.$emit("added", invoice.data.invoice);
      // CostsService.addNewCost(this.newData).then((res) => {
      //   this.$emit("added", res.data.invoice);
      // });
    },

    onContactItemClick: function (contacts) {
      const contact_ids = Array.from(contacts);
      console.log("contacts", contacts);
      console.log("contact_ids", contact_ids);
      this.selectedContacts = contact_ids;
      this.newData.contact_id =
        contact_ids && contact_ids.length > 0
          ? contact_ids[contact_ids.length - 1]
          : 0;
      // console.log(this.newData);
    },
    onValidation: function (name, value) {
       this.$set(this.validationResult, name, value);
      console.log(this.validationResult,name, value);
      // console.log(id, validationResult);
    },
    onTextFieldValueChange: function (name, value) {
      this.newData[name] = value;
      console.log("newData", this.newData);
    },
    onDropdownChange: function (name, value) {
      this.newData[name] = value.value;
    },
    onContactSearched:function(searchString){
      CostsService.searchContactCostAddModal(searchString).then(res=>{
        //console.log("RES",res)
        this.costData.contacts = res.data.contacts
      });
    }
  },
};
</script>

<style lang="scss">
.cmp-accounting-costs-add_costs {
  .dt-table2 {
    --body-height: 200px !important;
  }
  .dt-modal--options {
  button {
    &:first-child {
      margin-right: 20px;
    }
    &:last-child {
      margin-left: 0px 10px;
    }
  }
}
}
</style>
